// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { wishListSharingStatusStyles } from "@insite/content-library/Components/WishListSharingStatus";
import { IconWrapper } from "@insite/mobius/Icon";
import AlertInfo from "@steiner/XDL/Icons/AlertInfo";
import { color } from "@steiner/XDL/Utilities";
import { css } from "styled-components";

wishListSharingStatusStyles.statusText = {
    css: css`
        &.private {
            font-size: 12px;
            font-weight: 600;

            &&&& {
                ${IconWrapper} {
                    position: relative;
                    top: 4px;
                    left: 4px;
                }
            }
        }
    `,
};

wishListSharingStatusStyles.privateTooltip = {
    iconProps: {
        color: "primary",
        src: AlertInfo,
        size: 14,
    },
};